import React from 'react';
import { Badge } from '@/components/ui/badge';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { ACTION_STATUS_OPTIONS } from 'components/IAP/ICSConstants';

type BadgeVariant = React.ComponentProps<typeof Badge>['variant'];

// Colours mirror the status badges in ActionsTable
const STATUS_BADGE_VARIANTS: Record<string, BadgeVariant> = {
  Planned: 'blue',
  'Current/Ongoing': 'amber',
  Closed: 'green',
  Blocked: 'destructive',
};

export const ActionStatusBadge: React.FC<{ status: string }> = ({ status }) => (
  <Badge variant={STATUS_BADGE_VARIANTS[status] ?? 'secondary'}>{status}</Badge>
);

type ActionStatusSelectProps = {
  value: string;
  onChange: (status: string) => void;
  'aria-label'?: string;
  id?: string;
  className?: string;
};

/** Status dropdown that shows the selected status and every option as a badge. */
const ActionStatusSelect: React.FC<ActionStatusSelectProps> = ({
  value,
  onChange,
  'aria-label': ariaLabel,
  id,
  className,
}) => (
  <Select
    items={ACTION_STATUS_OPTIONS}
    value={value}
    onValueChange={(next) => {
      if (typeof next === 'string' && next) onChange(next);
    }}
  >
    <SelectTrigger id={id} className={className} aria-label={ariaLabel}>
      <SelectValue>
        {(selected: string | null) =>
          selected ? <ActionStatusBadge status={selected} /> : 'Select...'
        }
      </SelectValue>
    </SelectTrigger>
    <SelectContent alignItemWithTrigger={false}>
      {ACTION_STATUS_OPTIONS.map((option) => (
        <SelectItem key={option.value} value={option.value}>
          <ActionStatusBadge status={option.value} />
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);

export default ActionStatusSelect;
